import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem,Image } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useRef, useMemo} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns/format";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import { modalAtom } from "../../../context";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { all } from "axios";
import ReactSelect from "../../../components/Select";
import moment from "moment";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}

const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`


export default function AllStudentReport() {
  const [activeIndex] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  // filters
  const [search, set_search] = useState<string>("");
  const [selected_level, set_selected_level] = useState<number | null>(null);
  const [selected_examperiod, set_selected_examperiod] = useState<number | null>(null);
  const [selected_student_status, set_selected_student_status] = useState<string | null>(null);

  // pagination
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 100;

  // states
  const [cachedData, setCachedData] = useState<any[]>([]);
  const [allServerItems, setAllServerItems] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const searchDebounceRef = useRef<number | null>(null);

  // fetch levels
  const { data: allLevel = [] } = useQuery(["exemption"], async () => {
    const res = await apiCall().get(`/setup/GetAllExemption`);
    return Array.isArray(res.data?.Data) ? res.data.Data : res.data;
  });

  // fetch exam periods
  const { data: allExamPeriod = [] } = useQuery(["exam-period"], async () => {
    const res = await apiCall().get(`exam/setup/examPeriod`);
    return Array.isArray(res.data?.Data) ? res.data.Data : res.data;
  });

  // main data fetch
  const queryKey = [
    "all-student-server",
    currentPage,
    itemsPerPage,
    selected_examperiod,
    selected_level,
    selected_student_status,
  ];

  const { data, isLoading, isFetching, refetch } = useQuery(
    queryKey,
    async () => {
      const params: any = {
        PageNumber: currentPage + 1,
        PageSize: itemsPerPage,
      };
      if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
      if (selected_level) params.LevelId = selected_level;
      if (selected_student_status) params.studentStatusPrompt = selected_student_status;
      const res = await apiCall().get(`Exam/GetAllStudent`, { params });
      return res.data ?? {};
    },
    {
      keepPreviousData: true,
      staleTime: 1000 * 30,
      onSuccess: (data) => {
        const pageItems = data?.reportItems ?? data?.Data ?? [];
        setCachedData((prev) => {
          const newData = [...prev];
          pageItems.forEach((item: any) => {
            if (!newData.some((x) => x.StudentNo === item.StudentNo)) newData.push(item);
          });
          return newData;
        });
      },
      onError: (err) => console.error("Fetch students error:", err),
    }
  );

  const serverItems: any[] = data?.reportItems ?? data?.Data ?? [];
  const totalCount: number = data?.TotalCount ?? data?.TotalSize ?? 0;
  const pageCount = Math.max(1, data?.PageCount ?? Math.ceil(totalCount / itemsPerPage));

  // displayed data
  const [displayedItems, setDisplayedItems] = useState<any[]>([]);
  useEffect(() => {
    let filtered = [...(cachedData.length ? cachedData : serverItems)];
    if (search.trim()) {
      const term = search.trim().toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.StudentNo?.toLowerCase().includes(term) ||
          item.FirstName?.toLowerCase().includes(term) ||
          item.LastName?.toLowerCase().includes(term)
      );
    }
    setDisplayedItems(filtered);
  }, [serverItems, cachedData, search]);

  // 🔹 Optimized Debounced Search (parallel)
  useEffect(() => {
    if (!search.trim()) {
      setAllServerItems([]);
      setIsSearching(false);
      return;
    }

    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);

    searchDebounceRef.current = window.setTimeout(async () => {
      setIsSearching(true);
      setAllServerItems([]);

      try {
        const term = search.trim().toLowerCase();

        // fetch first page to get total
        const firstPageRes = await apiCall().get(`Exam/GetAllStudent`, {
          params: {
            PageNumber: 1,
            PageSize: itemsPerPage,
            ExamPeriodId: selected_examperiod ?? undefined,
            LevelId: selected_level ?? undefined,
            studentStatusPrompt: selected_student_status ?? undefined,
          },
        });

        const totalCount = firstPageRes.data?.TotalCount ?? firstPageRes.data?.TotalSize ?? 0;
        const totalPages = Math.ceil(totalCount / itemsPerPage);

        const batchSize = 10;
        let foundStudent: any = null;

        for (let i = 0; i < totalPages && !foundStudent; i += batchSize) {
          const batch = Array.from({ length: batchSize }, (_, j) => i + j + 1)
            .filter((page) => page <= totalPages)
            .map((page) =>
              apiCall()
                .get(`Exam/GetAllStudent`, {
                  params: {
                    PageNumber: page,
                    PageSize: itemsPerPage,
                    ExamPeriodId: selected_examperiod ?? undefined,
                    LevelId: selected_level ?? undefined,
                    studentStatusPrompt: selected_student_status ?? undefined,
                  },
                })
                .then((res) => res.data?.reportItems ?? res.data?.Data ?? [])
                .catch(() => [])
            );

          const results = await Promise.all(batch);
          const combined = results.flat();

          foundStudent = combined.find(
            (s: any) =>
              s.StudentNo?.toLowerCase().includes(term) ||
              s.FirstName?.toLowerCase().includes(term) ||
              s.LastName?.toLowerCase().includes(term)
          );

          if (foundStudent) {
            setAllServerItems([foundStudent]);
            break;
          }
        }

        if (!foundStudent) setAllServerItems([]);
      } catch (err) {
        console.error("Search error:", err);
      } finally {
        setIsSearching(false);
      }
    }, 400);

    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, [search, selected_examperiod, selected_level, selected_student_status]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => set_search(e.target.value);

  const handleFilter = (value: any, type: string) => {
    if (type === "level") set_selected_level(value ? Number(value) : null);
    else if (type === "period") set_selected_examperiod(value ? Number(value) : null);
    else if (type === "studentStatus")
      set_selected_student_status(value && value !== "All" ? value : null);
    else handleReload();
    setCurrentPage(0);
    setCachedData([]);
    refetch();
  };

  const handleReload = () => {
    set_search("");
    set_selected_level(null);
    set_selected_examperiod(null);
    set_selected_student_status(null);
    setCurrentPage(0);
    setCachedData([]);
    refetch();
  };

  const handlePageClick = (event: any) => {
    const selected = event.selected;
    setCurrentPage(selected >= pageCount ? 0 : selected);
  };

  // 🔹 Download
  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationFn: async () => {
      const params: any = {};
      if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
      if (selected_level) params.LevelId = selected_level;
      if (selected_student_status) params.studentStatusPrompt = selected_student_status;
      params.PageNumber = 1;
      params.PageSize = itemsPerPage;
      const query = new URLSearchParams(params).toString();
      const url = `/ExamReport/downloadAllStudentsReport?${query}`;
      const res = await apiCall().post(url, {}, { responseType: "blob" });
      return res;
    },
    onSuccess: (res: any) => {
      const blob = new Blob([res.data], { type: res.data.type || "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "All-Students-Report.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      set_notification({ type: "success", message: "All Student Report downloaded Successfully" });
      set_Nopen(true);
    },
    onError: (err: any) => {
      set_notification({
        type: "error",
        message: err?.data?.Message || err?.message || "Error occurred",
      });
      set_Nopen(true);
    },
    onSettled: () => set_open(false),
  });

  const start = displayedItems.length ? currentPage * itemsPerPage + 1 : 0;
  const end = Math.min(start + displayedItems.length - 1, totalCount);

  const renderItems = isSearching
    ? []
    : search.trim()
    ? allServerItems.length
      ? allServerItems
      : []
    : displayedItems;

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="All Students Report"
            button_array={[
              <Button
                color="white"
                bg="var(--dark-green-color)"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownload()}
                disabled={isDownloading}
              >
                {isDownloading ? "Downloading..." : "Download All Students Report"}
              </Button>,
            ]}
          />

          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="300px" bg="white" borderColor="green">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>
              <Input
                value={search}
                onChange={handleSearch}
                type="text"
                placeholder="Search by StudentNo or Name"
              />
              <span
                style={{ position: "absolute", right: 10, cursor: "pointer", top: 12 }}
                onClick={handleReload}
              >
                <ReloadIcon />
              </span>
            </InputGroup>

            <Select
              placeholder="Level"
              width="140px"
              bg="white"
              borderColor="green"
              onChange={(e) => handleFilter(e.target.value, "level")}
              value={selected_level ?? ""}
            >
              <option value="">All Levels</option>
              {allLevel.map((eType: any) => (
                <option key={eType.Id} value={eType.Id}>
                  {eType.Name}
                </option>
              ))}
            </Select>

            <Select
              placeholder="Student Status"
              width="160px"
              bg="white"
              borderColor="green"
              onChange={(e) => handleFilter(e.target.value, "studentStatus")}
              value={selected_student_status ?? ""}
            >
              <option value="">All</option>
              <option value="Current">Current</option>
              <option value="Completed">Completed</option>
            </Select>

            <Button onClick={handleReload} color="white" bg="green">
              Reset Filters
            </Button>
          </Flex>

          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading fontSize="1rem">All Students Report</Heading>
            <Text fontSize=".8rem">
              Showing {start} - {end} of {totalCount} {isFetching ? "(loading...)" : ""}
            </Text>
          </Flex>

          {isSearching ? (
            <Box textAlign="center" color="green" mt={4}>
              Searching for student...
            </Box>
          ) : renderItems.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                   <Tr>
                     <Th sx={HeadStyle}>Title</Th>
                     <Th sx={HeadStyle}>StudentNo</Th>
                     <Th sx={HeadStyle}>First Name</Th>
                     <Th sx={HeadStyle}>Last Name</Th>
                     <Th sx={HeadStyle}>Previous-Level</Th>
                     <Th sx={HeadStyle}>Level</Th>
                     <Th sx={HeadStyle}>Reg.Date</Th>
                    <Th sx={HeadStyle}>Phone</Th>
                     <Th sx={HeadStyle}>Email</Th>
                    <Th sx={HeadStyle}>Induction</Th>
                    <Th sx={HeadStyle}>Address</Th>
                     <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                 </Thead>
                  <Tbody>
                  {renderItems.map((eCandidate: any, index: number) => (
                    <ROWSTYLE key={eCandidate.SN ?? eCandidate.StudentNo ?? index}>                       <Td sx={DataStyle}>{eCandidate?.Title || 'N/A'}</Td>
                      <Td sx={DataStyle}>{eCandidate?.StudentNo || 'N/A'}</Td>
                      <Td sx={DataStyle}>{eCandidate?.FirstName || 'N/A'}</Td>
                      <Td sx={DataStyle}>{eCandidate?.LastName || 'N/A'}</Td>                       <Td sx={DataStyle}>{eCandidate.PreviousLevel || 'N/A'}</Td>                       <Td sx={DataStyle}>{eCandidate.Level || 'N/A'}</Td>
                      <Td sx={DataStyle}>{moment(eCandidate.RegistrationDate).format("yyyy-MM-DD")}</Td>
                      <Td sx={DataStyle}>{eCandidate.PhoneNumber}</Td>
                       <Td sx={DataStyle}>{eCandidate.Email}</Td>
                       <Td sx={DataStyle}>{eCandidate.InductionStatus}</Td>
                       <Td title={eCandidate?.Address} sx={{...DataStyle,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxW:'150px'}}>{eCandidate.Address ||'N/A'}</Td>
                       <Td sx={DataStyle} minW="60px" w="50px" h="50px">                         <div className={activeIndex === index ? 'active' : ''}><Option {...{ index, candidate: eCandidate }} /></div>
                      </Td>
                     </ROWSTYLE>
                   ))}
                 </Tbody>
              </Table>
            </TableContainer>
          ) : search ? (
            <Box textAlign="center" color="red" mt={4}>
              Student not found
            </Box>
          ) : (
            <Text>No Student Report Found</Text>
          )}

          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              forcePage={currentPage}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}



const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
 

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Flex align="center" gap="20px">
    {/* <Image
        src={props?.candidate.ImageUrl ? props?.candidate.ImageUrl:img}
        width="150px"
        height="150px"
        borderRadius="50px"
        objectFit="cover"
        objectPosition="center"
        alt="profile"
      /> */}
      <Flex flexDir="column">
        <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading>
        <Text>Student</Text>
        <Text>ID: {props.candidate.StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="repeat(3,1fr)"  gap="30px">
    <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Previous-Level</Text>
        <Text fontWeight="500">{props.candidate?.PreviousLevel||'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level||'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)"> Registration Date</Text>
        <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
        <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
        <Text fontWeight="500">{props.candidate.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Induction</Text>
        <Text fontWeight="500"># {props.candidate.InductionStatus}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate.Address}</Text>
      </GridItem> 
    </Grid>
  </Flex>
  )}
